import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useEnfesto } from '../../../../contexts/Corte/ControleEnfesto/EnfestoContext';

import styles from '../../../../styles/Corte/ControleEnfesto/Enfesto.module.scss';

const ModalCancelar = () => {

    const { showCancelar,  handleCloseCancelar, handleCancelaEnfesto } = useEnfesto();

    return (
        <>
            <Modal
                show={showCancelar}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header className={styles.modalHeaderCancel}>
                    <Modal.Title>Deseja cancelar o enfesto?</Modal.Title>
                </Modal.Header>
                <Modal.Body className={styles.modalBodyCancel}>
                    <Button 
                        className={styles.modalBtnCancel}
                        variant='success'
                        onClick={handleCancelaEnfesto}
                    >
                        Sim
                    </Button>
                    <Button 
                        className={styles.modalBtnCancel}
                        variant='danger'
                        onClick={handleCloseCancelar}
                    >
                        Não
                    </Button>
                </Modal.Body>

            </Modal>
        </>
    )

}

export default ModalCancelar;